import axios from '@/api/config';

const schedule = {
  getScheduleById(data) {
    return axios.get(`${process.env.BASE_URL}/schedule/getSchedule/` + data, {});
  },
  getSchedule(data) {
    return axios.get(`${process.env.BASE_URL}/schedule/getSchedule`, {params: data});
  },
  getScheduleList() {
    return axios.get(`${process.env.BASE_URL}/schedule/getScheduleList`, {});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/schedule/pageList`, data);
  },
  addSchedule(data) {
    return axios.post(`${process.env.BASE_URL}/schedule/addSchedule`, data);
  },
  updateSchedule(data) {
    return axios.put(`${process.env.BASE_URL}/schedule/updateSchedule`, data);
  },
  deleteSchedule(data) {
    return axios.delete(`${process.env.BASE_URL}/schedule/deleteSchedule`, data);
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/schedule/exportExcel`, {params: data});
  },
  importData() {
    return axios.post(`${process.env.BASE_URL}/schedule/importData`, data);
  },
  trigger(data) {
    return axios.post(`${process.env.BASE_URL}/schedule/trigger`, data);
  },
  resume(data) {
    return axios.post(`${process.env.BASE_URL}/schedule/resume`, data);
  },
  pause(data) {
    return axios.post(`${process.env.BASE_URL}/schedule/pause`, data);
  },
}

export default schedule;



// WEBPACK FOOTER //
// ./src/api/schedule.js